/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./src/js/factory/ServiceFactory.js
// import { dependencyTwo } from '../dependencies/dependencyTwo.js';

class ServiceFactory {
  createService(serviceName) {
    switch (serviceName) {
      case 'product-variant-selector-handler':
        const dependencyOne = window.theme?.productVariantSelectorHandlerDependency;
        const dependencyTwo = new dependencyTwo(dependencyOne);
        if (!dependencyOne || !dependencyTwo) {
          throw new Error('Dependency error in product variant selector handler');
        }
        return new window.theme.ProductVariantSelectorHandler(dependencyOne);
      default:
        throw new Error('Service not found');
    }
  }
}
;// CONCATENATED MODULE: ./src/js/utils/CardButtonPosition.js
class CardButtonPosition {
  constructor(selector = '.card-wrapper') {
    this.selector = selector;
    this.handleResize = this.update.bind(this);
  }
  init() {
    this.update();
    window.addEventListener('load', this.handleResize);
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mouseover', e => {
      const card = e.target.closest(this.selector);
      if (card && !card.dataset.updated) {
        this.update();
        card.dataset.updated = 'true';
      }
    });
    if (Shopify?.designMode) {
      window.addEventListener('shopify:section:load', this.handleResize);
      window.addEventListener('shopify:section:unload', this.handleResize);
    }
  }
  update() {
    const cards = document.querySelectorAll(this.selector);
    cards.forEach(card => {
      const media = card.querySelector('.card__media');
      const button = card.querySelector('.card-information__button');
      if (media && button) {
        const offsetTop = media.offsetTop + media.offsetHeight - button.offsetHeight;
        card.style.setProperty('--card-button-top', `${offsetTop}px`);
      }
    });
  }
  destroy() {
    window.removeEventListener('load', this.handleResize);
    window.removeEventListener('resize', this.handleResize);
    if (Shopify?.designMode) {
      window.removeEventListener('shopify:section:load', this.handleResize);
      window.removeEventListener('shopify:section:unload', this.handleResize);
    }
  }
}
;// CONCATENATED MODULE: ./src/js/entrypoint/global/theme-mad.js


const cardPosition = new CardButtonPosition();
cardPosition.init();
document.addEventListener('DOMContentLoaded', () => {
  const serviceFactory = new ServiceFactory();

  // const productVariantSelectorHandler = serviceFactory.createService('product-variant-selector-handler');
  // productVariantSelectorHandler.init();
});
/******/ })()
;